export default __webpack_public_path__ + "static/us-consumer-product-faq-bg-mobile-09f87dbe2c0ceedd5f5066848b8941b6.jpg";